import React, { useState } from "react";
import { ColumnProps } from "antd/lib/table/interface";
import Layout from "../components/Layout";
import StuTable from "../components/StuTable";
import useRequest from "../../../../utils/useRequest";
import {
    getExamStudentLeaveScreenList,
    StudentLeaveScreenListItem
} from "../../../../service/exam";
import InvigilationProvider from "../context";
import AsideShift from "./components/AsideShift";

export default function ShiftBrowser() {
    const [examId, setExamId] = useState("");
    const [studentName, setStudentName] = useState("");

    const [data, { loading }, refresh] = useRequest(
        () => getExamStudentLeaveScreenList({ studentName, examId }),
        {},
        [examId, studentName]
    );

    const columns: ColumnProps<StudentLeaveScreenListItem>[] = [
        {
            title: "切屏次数",
            dataIndex: "leaveScreenCount",
            align: "center"
        }
    ];

    return (
        <InvigilationProvider
            examList={data?.conditionQueryList || []}
            dataSource={data?.dataList || []}
            examId={examId}
            setExamId={setExamId}>
            <Layout
                refresh={refresh}
                title="考生切屏记录"
                table={
                    <StuTable
                        onErrChange={refresh}
                        extraColumns={columns}
                        buttonShow={[true, false, true, true]}
                        dataSource={data?.dataList || []}
                        loading={loading}
                    />
                }
                aside={<AsideShift />}
                onSearch={setStudentName}
            />
        </InvigilationProvider>
    );
}
